import script from "./details.vue?vue&type=script&setup=true&lang=js"
export * from "./details.vue?vue&type=script&setup=true&lang=js"

import "./details.vue?vue&type=style&index=0&id=3a95adfa&scoped=true&lang=less"

import exportComponent from "/data/opt/jenkins/workspace/prod/建博会大药房/dms-web-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a95adfa"]])

export default __exports__